import { render, staticRenderFns } from "./SystemDictionary.vue?vue&type=template&id=34faf0e6&scoped=true&"
import script from "./SystemDictionary.vue?vue&type=script&lang=js&"
export * from "./SystemDictionary.vue?vue&type=script&lang=js&"
import style0 from "./SystemDictionary.vue?vue&type=style&index=0&id=34faf0e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34faf0e6",
  null
  
)

export default component.exports